
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import './style.css';

const ItemComponent =(props)=>{
  const { random, imgCss, imgStyles, className } = props;

  const navigate = useNavigate();

  const goToPageBook=(book)=>{
    navigate(`/editorial/books/${book._id}`);
  }

  const goToPageAuthor=(book)=>{
    navigate(`/editorial/authors/${book._id}`);
  }

  return (
    <div className={`home-card card ${className}`}>
      <div className="home-header card-header image-link"
        onClick={
          random.firstName ? ()=>goToPageAuthor(random): ()=>goToPageBook(random)
        }
      >
        <img 
          alt={random.firstName ? random.photo || '/assets/app/author.png' : random.coverImage || '/assets/app/cover.jpg'} 
          className={`fit-cover card-thumbnail-top ${imgCss}`} 
          src={random.firstName ? random.photo || '/assets/app/author.png' : random.coverImage || '/assets/app/cover.jpg'} 
          style={imgStyles}
        />
      </div>
      <div className="home-body card-body" style={{ textAlign:'center' }}>
        <Link 
          to={random.firstName? `/editorial/authors/${random._id}`: `/editorial/books/${random._id}`}
          style={{ textDecoration:'none', color:'#e71c24' }}
          className="line-clamp"
        >
            {random.firstName? `${random.firstName} ${random.lastName}` : random?.title }
        </Link>
      </div>
    </div>
  )
}

export default ItemComponent;